export const IGetAssetsUseCaseType = Symbol('IGetAssetsUseCase');
